import { render } from "./ImportTasks.vue?vue&type=template&id=72aa62f1&scoped=true"
import script from "./ImportTasks.vue?vue&type=script&lang=js"
export * from "./ImportTasks.vue?vue&type=script&lang=js"

import "./ImportTasks.vue?vue&type=style&index=0&id=72aa62f1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72aa62f1"]])

export default __exports__